import { useQuery } from '@apollo/client'
import { useRouter } from 'next/router'
import {
  localeToMarketCode,
  apolloClient,
  Faqs_Filter,
  Faqs_Translations_Filter,
  Faq_Categories_Filter,
  Faq_Categories_Translations_Filter,
  GetFaqsAndCategoriesQuery,
  GetFaqsAndCategoriesQueryVariables,
  GET_FAQS_AND_CATEGORIES_QUERY,
} from '@instabox/consumer-web-shared'

const useFaqsAndCategories = () => {
  const { locale } = useRouter()
  const faqFilter: Faqs_Filter = {
    markets: {
      markets_code: {
        code: {
          _eq: localeToMarketCode(locale),
        },
      },
    },
  }
  const categoryFilter: Faq_Categories_Filter = {
    type: {
      _neq: 'sub',
    },
  }
  const translationFilter: Faqs_Translations_Filter | Faq_Categories_Translations_Filter = {
    languages_code: {
      _eq: locale,
    },
  }
  return useQuery<GetFaqsAndCategoriesQuery, GetFaqsAndCategoriesQueryVariables>(
    GET_FAQS_AND_CATEGORIES_QUERY,
    {
      // @ts-ignore
      client: apolloClient,
      fetchPolicy: 'cache-first',
      variables: {
        faqs_filter: faqFilter,
        faq_categories_filter: categoryFilter,
        faq_categories_translations_filter: translationFilter,
        faqs_translations_filter: translationFilter,
      },
    },
  )
}

export default useFaqsAndCategories
